<template>
<basepage title="E Fatura Mükellef Sorgulama" :status="status">

  <template slot="toolbar">
    <v-text-field v-model="vkn" flat="" solo-inverted="" hide-details :label="$t('Search')" append-icon="search"></v-text-field>
    <v-btn :disabled="status.loading" flat @click="ara()">Ara</v-btn>

  </template>

  <v-card>
    <v-btn :disabled="status.loading" color="info" @click="sorgulaTumu()"> {{$t('Inquire-All-Current-Accounts')}} </v-btn>

    <v-data-table :headers="headers" :items="mukellef" class="elevation-1">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.identifierNumber }}</td>
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.alias }}</td>
      </template>


    </v-data-table>
  </v-card>

</basepage>
</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "../coper/tools";

export default {
  components: {
    basepage,
  },
  data() {
    return {
      status: tool.NewSatatus(),
      vkn: "9240492097",
      mukellef: [],

      headers: [{
          text: 'identifierNumber',
          value: 'identifierNumber'
        },
        {
          text: 'title',
          value: 'title'
        },
        {
          text: 'alias',
          value: 'alias'
        },

      ],
    };
  },
  methods: {
    ara() {
      var prm = {
        VKN: this.vkn,
      };

      this.status.loading = true;
      tool.api_post(this, "EFatura/VKN_Sorgula", prm).then(

        response => {
          this.mukellef = response.body;
          this.status.loading = false;
          if (this.mukellef.length == 0) {
            this.status.text = this.$t('No-Records-Found')
            this.status.show = true;
          }

        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
    sorgulaTumu() {
      var prm = {};

      this.status.loading = true;
      tool.api_post(this, "EFatura/VKN_SorgulaTumu", prm).then(

        response => {
          this.status.loading = false;
          this.status.text = response.body + ' Adet Cari Sorgulandı';
          this.status.show = true;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );
    }

  }

};
</script>
